import Model from "./abstract/Model";
import Company from "./Company";
import ContractTemplate from "./ContractTemplate";

export default class Client extends Model {

    constructor(props) {
      super();

      this.initializeAttributes(props, {
        'company': Company,
        'contract_templates': (value) => ContractTemplate.list(value)
      });
    }
}
